<div
  #content
  class="content">
  <ng-template #placeholder></ng-template>
</div>
